import { Config } from './utils';

declare global {
  interface Window {
    Statsig?: any;
    __statsigReady?: Promise<any>;
    statsigClient?: any;
  }
}

export async function initStatsig(getUser: () => { userID?: string; email?: string }) {
  const sdk = await window.__statsigReady;
  const { StatsigClient } = sdk;
  const user = getUser() || {};
  const client = new StatsigClient(Config.statsig, user, {
    disableAutoMetricsLogging: true,
  });

  await client.initializeAsync();
  window.statsigClient = client;
  return client;
}

export function checkGate(name: string): boolean {
  const w = window as any;
  // Local dev override: `window.__perfFlags = { perf_calc_parallel_save: true }`
  if (w.__perfFlags && typeof w.__perfFlags[name] === 'boolean') {
    return w.__perfFlags[name];
  }
  const client = w && w.statsigClient;

  if (!client || typeof client.checkGate !== 'function') {
    return false;
  }
  try {
    return !!client.checkGate(name);
  } catch {
    return false;
  }
}
